import React, { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import ResponseField from "../children/ResponseField";
import Skeleton from "react-loading-skeleton";
import { getInspectionRequest } from "../../../../redux/action/inspectionRequest";
import AuctionTimeAndLocation from "../../buyer/AuctionDetail/Inspection/children/AuctionTimeAndLocation";

function InspectionResponse() {
  const isMobile = useMediaQuery({ query: "(max-width: 730px)" });
  const [auctionDetailsData, setAuctionDetailsData] = useState({});
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();
  const { requestGetData, loadings } = useSelector(
    (state) => state?.inspectionrequestion
  );

  useEffect(() => {
    dispatch(getInspectionRequest());
  }, [dispatch]);

  useEffect(() => {
    const filterData = requestGetData?.filter((item) => {
      return item?._id === id;
    });
    setAuctionDetailsData(filterData[0]);
  }, [id, requestGetData]);

  return (
    <div className="mt-1">
      <span className="valign-wrapper" style={{ gap: "15px" }}>
        <span
          className="material-icons-outlined pointer"
          onClick={() => navigate("/inspectList")}
        >
          arrow_back
        </span>
        <h3 className="">Inspection Response</h3>
      </span>
      <div
        className={`cover white z-depth-1 ${
          isMobile ? "p-1" : "p-2"
        } container flex column gap-1`}
      >
        <b className="font-20px font-weight-600" style={{ flex: "0.96" }}>
          Auction ID:{" "}
          <span className="cercle-purple-text">
            {loadings ? (
              <Skeleton width={300} />
            ) : (
              auctionDetailsData?.auction?.auctionId
            )}
          </span>
        </b>
        <AuctionTimeAndLocation
          auctioDetailsData={auctionDetailsData?.auction}
          loading={loadings}
        />
        <ResponseField
          auctionDate={auctionDetailsData?.auction?.auctionSchedule?.startDate}
        />
      </div>
    </div>
  );
}

export default InspectionResponse;
